import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c62223e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emoji-panel" }
const _hoisted_2 = {
  key: 0,
  class: "emoji-panel-group-title"
}
const _hoisted_3 = { class: "emoji-group-list" }
const _hoisted_4 = ["onClick"]

import groups from '@teams/common/config/emoji'

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    selectIcon: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', emoji: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectIcon: string
}




const select = (emoji: string) => {
  emit('select', emoji)
}

return (_ctx: any,_cache: any) => {
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!

  return (_openBlock(), _createBlock(_component_n_scrollbar, { class: "emoji-scrollbar-rail" }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (group) => {
          return (_openBlock(), _createElementBlock("li", {
            key: group.title,
            class: "emoji-panel-group"
          }, [
            (group.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(group.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.info, (it, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: _normalizeClass(["emoji-group-list-item", 
              it === props.selectIcon ? 'emoji-group-list-item__select' : ''
            ]),
                  onClick: ($event: any) => (select(it))
                }, _toDisplayString(it), 11, _hoisted_4))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})